import React, { useState, useEffect } from 'react';
import "./JoinMooCommunity.css";
import { tabName } from "../../../../src/utils/constants";
import JoinTelegramModalSingle from '../../../components/common/joinTelegramModalSingle';
import MobileTab from './tabs/mobileTab';
import DesktopTab from './tabs/desktopTab';
import { Link } from 'react-router-dom';
import GaEventsTracker from "../../../components/common/GaEventsTracker";


const JoinMooCommunitys = (props) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const useGaEventsTracker = GaEventsTracker("External Links")

    const [openLive, setOpenLive] = useState(false)

    const [activeTab, setActiveTab] = useState("Mobile Tab")
    const [open, setOpen] = useState(false)
    const [url, setUrl] = useState("");


    const isActive = (tab) => {
        if (activeTab === tab) {
            return "active";
        }
        return "";
    }
    const renderTab = () => {
        switch (activeTab) {
            case tabName.MobileTab:
                return <MobileTab
                    OnClickPopHandle={onClickPopHandle} Url={url}
                    Open={open} OpenModal={() => setOpen(!true)} />
                break;
            case tabName.DesktopTab:
                return <DesktopTab OnClickPopHandle={onClickPopHandle} Url={url}
                    Open={open} OpenModal={() => setOpen(!true)} />
                break;
            default:
                return null
                break;
        }
    }

    const onClickPopHandle = (url, value) => {
        setOpen(value)
        setUrl(url)
    }

    const Redirect1 = (e) => {
        e.preventDefault()
        const section = document.querySelector("#howjoinStep");
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        useGaEventsTracker('event', 'howToJoin', {'event_category': 'Telegram'})
      }

    const ContactFacebook = () => {
        onClickPopHandle("https://www.facebook.com/MalaysiaWarrants/", true)
        useGaEventsTracker('event', 'Facebook', {'event_category': 'Telegram'})
    }

    return (
        <>
            <div id="MooCommunity" className="pageobj" style={{}}>
                <div className="welcometop">
                    <div className="video-wrapper">
                        <div className="welcomeimgtop xs-none">
                            <img src="/img/moocommunity/MooComm_header.jpg" />
                        </div>

                        <div className="welcomeimgtop xs-view">
                        <img src="/img/moocommunity/MooComm_mobile_header.jpg" />
                        </div>

                    </div>
                </div>
                <div className="jumbotron">
                    <div className="container-fluid">
                        <p className="lead" />
                        <h1
                            onClick={() => onClickPopHandle("https://t.me/Malaysiawarrants", true)}
                            className="broker_img title_join"

                        >
                            <b>Macquarie Warrants Malaysia </b>
                            is now on 
                            <b> Moo Community!</b>
                            {" "}
                            <img
                                className="imgtab"
                                src="/img/moocommunity/MooComm_Icon.png"
                            />
                        </h1>
                        <p />
                    </div>
                </div>
                <nav className="tabnav container-fluid sec_for_top">
                    <div className="row tabnav-row" style={{ display: 'block', overflow: "hidden" }}>
                        <div className="col-xs-9 col-sm-6 mobile_tele" style={{ position: 'relative', display: 'inline-block', float: 'left' }}>
                            <div className="navbox" >
                                <img
                                    style={{ width: "100%" }}
                                    src="/img/moocommunity/MooComm_Phone_FollowButton.png"
                                />
                                <div className="phoneScreen screenScroll">
                                    <img
                                        style={{ width: "100%" }}
                                        src="/img/moocommunity/MooComm_Phone_Content_Temporary.jpg"
                                    />
                                </div>
                                <div
                                    onClick={() => onClickPopHandle("https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374", true)}
                                    className="joinLink hidden-xs phone_join"

                                >
                                    &nbsp;
                                </div>
                                <div
                                    className="joinLink visible-xs phone_join"
                                    onClick={() => onClickPopHandle("https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374", true)}

                                >
                                    &nbsp;
                                </div>
                            </div>

                        </div>
                        <div className="col-xs-6 text_top_sec" style={{ width: '100%', maxWidth: '50%', display: 'inline-block' }}>
                            <div className="navbox howjoin">
                                <div id="howjoinStep">
                                    <div className="section" id="tab1">
                                        <p style={{ marginBottom: '15px' }}>
                                        You may now receive timely updates on news from the foreign
                                        and local markets via our Moo Community page for trading
                                        ideas and to help with your daily trading and decision making!
                                        </p>
                                        <p className="howJoinSubTitle">
                                        If you already have the Moomoo application:
                                        </p>
                                        <button
                                            onClick={() => onClickPopHandle("https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374", true)}
                                            className="btn broker_img now_join"
                                            style={{
                                                backgroundColor: "#F17322",
                                                color: "#ffffff",
                                                padding: "0 12px",
                                                marginLeft: "15px",
                                                verticalAlign: "baseline",
                                                diaplay: "none",
                                            }}
                                        >
                                            Join now
                                        </button>
                                        <p className="howJoinTitle">How do I join?</p>
                                        <table id="viewtab" className="ctab">
                                            <tbody>
                                                <tr>
                                                    <td onClick={() => setActiveTab(tabName.MobileTab)} className={`ctab-item ${isActive(tabName.MobileTab)}`} id="forMobile" data-value="M">
                                                        <span>for mobile</span>
                                                    </td>
                                                    <td className="ctab-item-space">&nbsp;</td>
                                                    <td
                                                        onClick={() => setActiveTab(tabName.DesktopTab)}
                                                        className={`ctab-item ${isActive(tabName.DesktopTab)}`}
                                                        id="forDesktop"
                                                        data-value="D"
                                                    >
                                                        <span>for desktop</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {renderTab()}
                                        <div className="section alldone">
                                            <div className="alldone-text">
                                                <p>
                                                All done! Stay tuned for more exclusive
                                                MooCommunity content coming up!
                                                </p>
                                            </div>
                                            <div className="cta-btn">
                                                <Link to="/education/getstarted" target="_blank" onClick={useGaEventsTracker('event', 'getStarted', {'event_category': 'Telegram'})}>
                                                    <img  src="/img/moocommunity/1737362288464232.jpg" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                <div id='joindirect'></div>
            </div>
            <JoinTelegramModalSingle
                Url={url}
                Open={open} OpenModal={() => setOpen(!true)} />
        </>
    );
}

export default JoinMooCommunitys;